<div *ngIf="!visible"></div>

<div
  *ngIf="visible"
  class="nav-button-container"
  [class.nav-button-container__left-gradient]="type === 'backward-top' && variant === 'horizontal'"
  [class.nav-button-container__right-gradient]="type === 'forward-bottom' && variant === 'horizontal'"
  [class.nav-button-container__top-gradient]="type === 'backward-top' && variant === 'vertical'"
  [class.nav-button-container__bottom-gradient]="type === 'forward-bottom' && variant === 'vertical'"
  [class.nav-button-container__horizontal]="variant === 'horizontal'"
  [class.nav-button-container__vertical]="variant === 'vertical'"
>
  <button
    type="button"
    class="nav-button-container__btn"
    tuiIconButton
    appearance="mono"
    [style.border-radius.%]="100"
    size="m"
    [iconStart]="icon"
    (click)="scrollPanel.emit(type)"
  ></button>
</div>
